import { render, staticRenderFns } from "./ButtonsSection.vue?vue&type=template&id=10037d0a&scoped=true&"
import script from "./ButtonsSection.vue?vue&type=script&lang=js&"
export * from "./ButtonsSection.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsSection.vue?vue&type=style&index=0&id=10037d0a&scoped=true&lang=scss&"
import style1 from "./ButtonsSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10037d0a",
  null
  
)

export default component.exports